export default "__VITE_ASSET__BI6ly4Bk__"